// @flow

import React, { Component } from 'react';
import FocusBody from 'components/FocusBody';
import Page from 'components/Page';
import logoBlackWide from 'themes/images/logo-black-wide.png';
import FormRow from 'components/FormRow';
import { homePath } from 'WebModule/app/routerPaths';
import { injectIntl } from 'react-intl';
import View from 'components/View';
import { DetailBottomBarConfirm } from 'components/DetailBottomBarItem';
import DetailBottomBar from 'components/DetailBottomBar';
import Heading from 'components/Heading';
import type { Style, Theme } from 'types';
import Text from 'components/Text';
import Version from 'components/Version';
import ImageBottomBar from '../../components/ImageBottomBar';
import FocusBottomBar from '../../components/FocusBottomBar';
import FocusContent from '../../components/FocusContent';

const styles = {
  page: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  text: (props, { components: { FocusPage } }) => ({
    ...FocusPage.text
  }),
  img: {
    marginLeft: 20,
    height: 20
  },
  error: (props, { components: { Login } }) => ({
    ...Login.error
  }),
  header: (props, theme: Theme): Style => ({
    ...theme.components.ExternalModule.SpecificCodeHeader,
    fontSize: '18px',
    width: '420px',
    alignItems: 'flex-start'
  }),
  regCodeText: {
    padding: '15px',
    width: '420px',
    backgroundColor: '#F1F1F1'
  },
  withValidationMessage: {
    left: 'calc(100% + 15px)',
    top: '32px'
  }
};

export class SpecificCodeForm extends Component {
  continue = () => {
    window.location.href = homePath;
  };

  render() {
    const { intl } = this.props;

    return (
      <Page title={intl.formatMessage({ id: 'specific-code.page-title' })}>
        <View isExpanded style={styles.page}>
          <View style={{ width: 500 }}>
            <FocusContent>
              <FocusBody>
                <View
                  isExpanded
                  isVertical
                  style={{ padding: 40, paddingBottom: 10, alignItems: 'center', width: '100%' }}>
                  <FormRow>
                    <Heading style={styles.header} scale={1.5}>
                      {intl.formatMessage({ id: 'completed.thank-you' })}
                    </Heading>
                  </FormRow>
                  {/* <FormRow> */}
                  {/*  <Text> */}
                  {/*    {`Lorem ipsum dolor sit amet, consectetur adipisicing elit. At beatae eaque earum enim iusto, */}
                  {/*    pariatur reprehenderit voluptates. */}
                  {/*    Aperiam consequatur eligendi eos id libero necessitatibus nesciunt perspiciatis porro quam quia. Aliquam?`} */}
                  {/*  </Text> */}
                  {/* </FormRow> */}
                  <FormRow>
                    <Text style={styles.regCodeText}>{`${intl.formatMessage({
                      id: 'completed.instructions.part-1'
                    })} ${
                      process.env.WEB_MODULE_URL
                        ? `${intl.formatMessage({ id: 'completed.instructions.part-2' })} ${
                            process.env.WEB_MODULE_URL
                          } ${intl.formatMessage({ id: 'completed.instructions.part-3' })} `
                        : ''
                    }${intl.formatMessage({
                      id: 'completed.instructions.part-4'
                    })} “${intl.formatMessage({ id: 'login.log-in' })}”`}</Text>
                  </FormRow>
                </View>
                <FocusBottomBar>
                  <ImageBottomBar>
                    <img src={logoBlackWide} alt="LoyalMAN" style={styles.img} />
                    <Version position="absolute" />
                  </ImageBottomBar>
                  <DetailBottomBar withShadow="false">
                    <DetailBottomBarConfirm
                      name={intl.formatMessage({ id: 'login.log-in' })}
                      onClick={this.continue}
                    />
                  </DetailBottomBar>
                </FocusBottomBar>
              </FocusBody>
            </FocusContent>
          </View>
        </View>
      </Page>
    );
  }
}

export default injectIntl(SpecificCodeForm);
